import { useState } from 'react';
import { useGate, useUnit } from 'effector-react';

import { BaseModal } from 'shared/ui/BaseModal';
import { SurveyForm } from 'entities/surveyForm';

import { $isShowFinalContent, SurveyFormModel, SurveyModalGate } from '../model';
import { SurveyModalContent } from './SurveyModalContent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const SurveyModal = ({ isOpen, onClose }: Props) => {
  useGate(SurveyModalGate);
  const [isShowForm, setIsShowForm] = useState(false);
  const isShowFinalContent = useUnit($isShowFinalContent);

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} height={isShowFinalContent ? '30vh' : 'auto'}>
      {!isShowFinalContent && isShowForm ? (
        <SurveyForm.Form model={SurveyFormModel} />
      ) : (
        <SurveyModalContent isShowFinalContent={isShowFinalContent} onClose={onClose} setIsShowForm={setIsShowForm} />
      )}
    </BaseModal>
  );
};
